import React, { useState } from 'react';
import { Calculator } from 'lucide-react';

const ROICalculatorPage = () => {
  const [purchasePrice, setPurchasePrice] = useState('');
  const [monthlyRent, setMonthlyRent] = useState('');
  const [expenses, setExpenses] = useState('');
  const [roi, setRoi] = useState<number | null>(null);

  const calculateROI = () => {
    const price = parseFloat(purchasePrice);
    const rent = parseFloat(monthlyRent);
    const annualExpenses = parseFloat(expenses);

    if (!isNaN(price) && !isNaN(rent) && !isNaN(annualExpenses)) {
      const annualRent = rent * 12;
      const netIncome = annualRent - annualExpenses;
      const calculatedRoi = (netIncome / price) * 100;
      setRoi(parseFloat(calculatedRoi.toFixed(2)));
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <Calculator className="w-8 h-8" />
          <h1 className="text-3xl font-bold">ROI Calculator</h1>
        </div>

        <div className="bg-card p-6 rounded-lg shadow-lg space-y-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium">Purchase Price ($)</label>
            <input
              type="number"
              value={purchasePrice}
              onChange={(e) => setPurchasePrice(e.target.value)}
              className="w-full p-2 rounded border bg-background"
              placeholder="Enter property purchase price"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Monthly Rent ($)</label>
            <input
              type="number"
              value={monthlyRent}
              onChange={(e) => setMonthlyRent(e.target.value)}
              className="w-full p-2 rounded border bg-background"
              placeholder="Enter expected monthly rent"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Annual Expenses ($)</label>
            <input
              type="number"
              value={expenses}
              onChange={(e) => setExpenses(e.target.value)}
              className="w-full p-2 rounded border bg-background"
              placeholder="Enter annual expenses"
            />
          </div>

          <button
            onClick={calculateROI}
            className="w-full bg-primary text-primary-foreground py-2 rounded hover:bg-primary/90 transition-colors"
          >
            Calculate ROI
          </button>

          {roi !== null && (
            <div className="mt-6 p-4 bg-muted rounded-lg">
              <h3 className="text-xl font-semibold mb-2">Results</h3>
              <p className="text-lg">
                Estimated Annual ROI: <span className="font-bold text-primary">{roi}%</span>
              </p>
              <p className="text-sm text-muted-foreground mt-2">
                Note: This is a simplified ROI calculation. Consider consulting with financial experts for a more detailed analysis.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ROICalculatorPage;